import { Injectable } from '@angular/core';
import { Adapter } from '../interfaces/adapter.interface';

export class Dropdown {
  constructor(
    public code: number = 0,
    public description: string = ''
  ){}
}

@Injectable({
    providedIn: 'root'
})
export class DropdownAdapter implements Adapter<Dropdown> {
  adapt(item: any): Dropdown {
    return new Dropdown(
        (item.code) ? item.code : item.id,
        (item.description) ? item.description : item.name
    );
  }

  reverseAdapt(item: Dropdown): any {
    return { }
  }
}


export interface DropdownOption {
  value: any;
  label: string;
  disabled?: boolean;
  selected?: boolean;
  icon?: string;
  description?: string;
  data?: any; // Additional metadata
}

export interface HierarchicalOption extends DropdownOption {
  parentValue?: any;
  parentLabel?: string;
  level?: number;
  children?: HierarchicalOption[];
  isParent?: boolean;
  isExpanded?: boolean;
}

export interface MultiSelectItem {
  id: any;
  name: string;
  selected: boolean;
  parentId?: any;
  parentName?: string;
  disabled?: boolean;
  indeterminate?: boolean; 
}

export interface RegionSiteOption {
  regionId: number;
  regionName: string;
  sites: Array<{
    siteId: number;
    siteName: string;
    selected?: boolean;
  }>;
  selected?: boolean;
  expanded?: boolean;
}

export interface UserAssignmentOption {
  userId?: number;
  username: string;
  name: string;
  userType: 'admin' | 'operator';
  assignedRegions: number[];
  assignedSites: number[];
  availableRegions: Array<{ id: number; name: string }>;
  availableSites: Array<{ id: number; name: string; regionId: number }>;
}

export interface FormFieldConfig {
  key: string;
  label: string;
  type: 'text' | 'email' | 'password' | 'tel' | 'select' | 'multiselect' | 'checkbox' | 'radio';
  required?: boolean;
  placeholder?: string;
  options?: DropdownOption[];
  validation?: {
    minLength?: number;
    maxLength?: number;
    pattern?: RegExp;
    customValidator?: (value: any) => string | null;
  };
  disabled?: boolean;
  readonly?: boolean;
  hint?: string;
  errorMessage?: string;
}

export interface FormSectionConfig {
  title: string;
  description?: string;
  icon?: string;
  fields: FormFieldConfig[];
  collapsible?: boolean;
  expanded?: boolean;
  required?: boolean;
}

export const USER_TYPE_OPTIONS: DropdownOption[] = [
  { value: 'admin', label: 'Administrator', icon: 'admin_panel_settings' },
  { value: 'operator', label: 'Operator', icon: 'person' }
];

export const STATUS_OPTIONS: DropdownOption[] = [
  { value: 1, label: 'Active', icon: 'check_circle' },
  { value: 0, label: 'Inactive', icon: 'cancel' }
];

export const ROLE_OPTIONS: DropdownOption[] = [
  { value: 'admin', label: 'Admin', description: 'Full system access' },
  { value: 'user', label: 'User', description: 'Operator level access' }
];